/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown>, caseNumber: NonNullable<unknown> }} Notifications_Task_Sla_Breach_Body_ExpandedInputs */

const en_notifications_task_sla_breach_body_expanded = /** @type {(inputs: Notifications_Task_Sla_Breach_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The task "${i?.task}" on case ${i?.caseNumber} needs attention.`)
};

const pt_br2_notifications_task_sla_breach_body_expanded = /** @type {(inputs: Notifications_Task_Sla_Breach_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A atividade "${i?.task}" no caso ${i?.caseNumber} precisa de atenção.`)
};

/**
* | output |
* | --- |
* | "The task \"{task}\" on case {caseNumber} needs attention." |
*
* @param {Notifications_Task_Sla_Breach_Body_ExpandedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_sla_breach_body_expanded = /** @type {((inputs: Notifications_Task_Sla_Breach_Body_ExpandedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Sla_Breach_Body_ExpandedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_sla_breach_body_expanded(inputs)
	return pt_br2_notifications_task_sla_breach_body_expanded(inputs)
});